<script setup>
import { ref } from 'vue';
import { useStore } from 'vuex';
import { __, __n } from 'JIX/gettext.js';

import DsIconButton from 'JIX/components/ds/DsIconButton.vue';
import FullScreenOverlay from 'JIX/components/FullscreenOverlay.vue';

import { useRefEventListener } from 'JIX/eventListener.js';

import { setDropdownMaxHeightOnOpen } from './composables.js';

const props = defineProps({
    submitButtonLabel: {
        type: String,
        required: true,
    },
    enableFullscreenOverlay: {
        type: Boolean,
        required: false,
        default: false,
    },
    enableMaxHeight: {
        type: Boolean,
        required: false,
        default: false,
    }
});
const emit = defineEmits(['reset', 'submit']);

const store = useStore();

const open = ref(false);
const button = ref();
const dropdown = ref();

useRefEventListener(ref(window), 'click', (event) => {
    if (!props.enableFullscreenOverlay && open.value && !button.value.contains(event.target) && !event.composedPath().includes(dropdown.value)) {
        open.value = false;
        if (Object.keys(store.state.searchQueryWorking).length !== 0){
            emit('submit');
        }
    }
});

useRefEventListener(ref(window), 'keydown', event => {
    if (event.key === 'Escape' || event.key === 'Enter') {
        open.value = false;
        if (event.key === 'Enter' && Object.keys(store.state.searchQueryWorking).length !== 0) {
            event.preventDefault();
            emit('submit');
        }
    }
});


if (props.enableMaxHeight){
    setDropdownMaxHeightOnOpen(button, dropdown, open);
}

defineExpose({
    open: () => open.value = true,
    close: () => open.value = false,
    toggle: () => open.value = !open.value,
});
</script>

<template>
    <button
        type="button"
        class="jobsearch-input__filter-button"
        :class="{ 'jobsearch-input__filter-button--opened': open }"
        ref="button"
        @click="open = !open"
        v-if="$slots.button"
    >
        <slot name="button" />
    </button>
    <div class="position-relative">
        <FullScreenOverlay v-model:open="open" v-if="enableFullscreenOverlay">
            <template #header>
                <h5 class="filter-window__mobile-title">
                    {{ __('Filtre') }}
                </h5>
                <DsIconButton
                    icon-name="close"
                    type="secondary"
                    size="md"
                    class="m-n3 align-self-center"
                    :label="__('Luk')"
                    @click.prevent="open = false"
                />
            </template>
            <template #body>
                <div class="filter-window mobile">
                    <slot name="content" />
                </div>
            </template>
            <template #footer>
                <button type="button" class="btn btn-tertiary btn-sm" @click="emit('reset')">
                    {{ __('Nulstil') }}
                </button>
                <button type="button" class="btn btn-primary btn-sm" @click="emit('submit'); open = false">
                    {{ submitButtonLabel }}
                </button>
            </template>
        </FullScreenOverlay>
        <Transition name="slide-down" v-else>
            <div
                ref="dropdown"
                v-if="open"
                class="filter-window"
            >
                <slot name="content" />
                <div class="filter-window__section-bottom">
                    <button type="button" class="btn btn-tertiary btn-sm" @click="emit('reset')">
                        {{ __('Nulstil') }}
                    </button>
                    <button type="button" class="btn btn-primary btn-sm" @click="emit('submit'); open = false">
                        {{ submitButtonLabel }}
                    </button>
                </div>
            </div>
        </Transition>
    </div>
</template>
